export default "__VITE_ASSET__LAkSF3mf__"